var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.5a.75.75 0 01-.75.75h-2.25v2.25a.75.75 0 11-1.5 0v-2.25H7.5a.75.75 0 110-1.5h2.25V7.5a.75.75 0 011.5 0v2.25h2.25a.75.75 0 01.75.75zm7.28 11.03a.75.75 0 01-1.06 0l-4.694-4.693a8.26 8.26 0 111.06-1.06l4.695 4.693a.751.751 0 010 1.06zM10.5 17.25a6.75 6.75 0 10-6.75-6.75 6.757 6.757 0 006.75 6.75z",
    fill: "#15131C"
  })));
}

export default SvgZoomIn;